<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            <app-pages :app_id="pageIds.compensation"></app-pages>
        </v-flex>

    </v-layout> 
</template>

<script>
import pageIds from '@/constants/app_ids'

export default {     
    name: 'CompensationMenu',
    metaInfo: {
        title: 'Compensation Menu',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Compensation Menu' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'app-pages': ()=> import('@/components/Common/PageMenu')
    },   
    data () {
        return {
            pageIds,
            error: false,
            errorMessage: '',
            loading: false,
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: 'Compensation and Benefits',
            headerPageTitle: 'Menu'
        })
    }
}
</script>